module.exports = __webpack_public_path__ + "img/babaev_500.d1d19f28.jpg";